import { masterApi } from './api';

export default async function fetchUsersData(accessToken) {
	const res = await masterApi.get('/user', {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			accept: '*/*',
		},
	});

	return res?.data;
}
